import { createFileRoute } from '@tanstack/react-router'

import { conflictsQuery, flagsQuery, productsQuery } from '../lib/queries'
import { Attention } from '../screens/Attention'

export const Route = createFileRoute('/attention')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(productsQuery()),
      context.queryClient.ensureQueryData(conflictsQuery()),
      context.queryClient.ensureQueryData(flagsQuery()),
    ]),
  component: Attention,
})
